import { Button, Icon } from '@pwc/pwc-deals-ui';
import React from 'react';
import { Link } from 'react-router-dom';

import './QuestionFooter.scss';

const QuestionFooter = ({
  onNext,
  onPrevious,
  skipPath,
  isNextDisabled,
  isBackDisabled,
}) => (
  <div className="question-footer">
    <Button
      className={`button-link question-back ${
        isBackDisabled ? 'inactive' : 'active'
      }`}
      disabled={isBackDisabled}
      onClick={onPrevious}
    >
      <Icon
        name="left-chevron"
        width="16px"
        className={`fill ${
          isBackDisabled ? 'icon-grey-medium' : 'icon-orange'
        } back`}
      />
      Back
    </Button>
    <div>
      <Link className="answer-later button-link" to={skipPath}>
        Answer Later
      </Link>
      <Button
        className="next-button"
        onClick={onNext}
        disabled={isNextDisabled}
      >
        Next
      </Button>
    </div>
  </div>
);

export default QuestionFooter;
